import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import useOnboardingKindText from '@/hooks/use-onboarding-kind-text';
import { onboardingHasPlaybook } from '../../onboardings-shared/utils';

/** The playbook tells onboardings apart better than the kind, which is usually the same for all of them. */
const useOnboardingTitle = () => {
  const $ = _c(2);
  const onboardingKindT = useOnboardingKindText();
  let t0;
  if ($[0] !== onboardingKindT) {
    t0 = onboarding => onboardingHasPlaybook(onboarding) && onboarding.playbook?.name || onboardingKindT(onboarding.kind);
    $[0] = onboardingKindT;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default useOnboardingTitle;